import { groupEntries } from './orgMenu.model'

/** Path relative to the event root: no leading / trailing slashes. */
export const relativeEventPath = (pathname = '', base = '') => {
    let rel = pathname.startsWith(base) ? pathname.slice(base.length) : pathname
    return rel.replace(/^\/+|\/+$/g, '')
}

/**
 * The menu entry matching the current page (mock `markActive`): an exact match on `to`; the event
 * page ("" ) is active on every hub tab since the whole hub is the event-page section. Returns
 * `{ entry, group }` so the parent group can be lightly marked.
 */
export function getActiveMenuEntry(rel, groups = [], hubTabPaths = []) {
    const path = String(rel || '').replace(/^\/+|\/+$/g, '')
    const isHub = path === '' || hubTabPaths.includes(path)
    for (const group of groups) {
        for (const entry of groupEntries(group)) {
            if (entry.to === '' ? isHub : entry.to === path) return { entry, group }
        }
    }
    return { entry: null, group: null }
}
